<template>
    <div class="peiso-toggle-container d-flex justify-content-between align-items-center gap-16">

        <span class="label">{{ labelTitle }}</span>
        <el-switch v-model="toggle" @change="handleChange" @input="handleInput" @click="handleClick()" :active-text="activeText" :inactive-text="inactiveText" size="large"/>
    </div>
</template>

<style lang="scss">
@import 'static/scss/fonts/fonts';
@import 'static/scss/colors';
    .peiso-toggle-container {
        margin: 1.5rem 0;
        .label {
            @include pingfang-font(18px, normal, 600, $white)
        }
        .el-switch {
            position: relative;
            .el-switch__label {
                &.is-active {
                    color: $pink1;
                }

                color: $gray8;
            }

            .el-switch__core {
                border-color: $white;
                background-color: $white;
                border: none;
                height: 35px;
                border-radius: 10px;
                width: 150px !important;

                &:after {
                    background-color: $pink1;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 50%;
                    border-radius: 10px 0 0 10px;
                }
            }

            &.is-checked {
                .el-switch__core {
                    border-color: $white;
                    background-color: $white;

                    &:after {
                        left: 100%;
                        margin-left: -50%;
                        border-radius: 0 10px 10px 0;
                    }
                }
            }

            .el-switch__label {
                color: $black1;
                @include montserrat-font(16px, normal, 400, $black1);
                &--left {
                    position: absolute;
                    margin-right: 0;
                    z-index: 1;
                    width: 50%;
                    text-align: center;
                    &.is-active {
                        color: $white;
                        font-weight: 700;
                        transition: 0.5s;
                    }
                }

                &--right {
                    position: absolute;
                    margin-left: 0;
                    z-index: 1;
                    width: 50%;
                    text-align: center;
                    right: 0;
                    &.is-active {
                        color: $white;
                        font-weight: 700;
                        transition: 0.3s;
                    }
                }

            }

            
        }

        &.width-200px {
            .el-switch__core {
                width: 200px !important;
            }
        }
    }
</style>

<script>
export default {
    data() {
        return {
            toggle: false
        }
    },
    
  watch: {
        value(newValue) {
            this.toggle = newValue
        }
  },

    props: {
        activeText: {
            default: 'Show'
        },
        inactiveText: {
            default: 'Hide'
        },
        labelTitle: {
            default: 'Label title here'
        },
        value: {
            default: false,
        },
        isAutoChange: {
            default: false
        }
    },

    methods: {
        handleChange(e) {
            if (!this.isAutoChange) {
                this.toggle = !e
                this.$emit('change-toggle', this.toggle)
                return
            }
        },

        handleInput(e) {
            if (!this.isAutoChange) {
                this.toggle = !e
                return
            }
        },

        handleClick() {
            this.$emit('change-toggle')
        }
    },

    mounted() {
        this.toggle = this.value
    }


    
}
</script>


// WEBPACK FOOTER //
// src/components/common/peisoToggle.vue